import { ReactComponent as MetaIcon } from 'assets/bosta-icons/Meta.svg';
import { ReactComponent as FacebookAndInstagram } from 'assets/bosta-icons/FacebookAndInstgram.svg';
import { ReactComponent as WhatsappIcon } from 'assets/bosta-icons/WhatsAppChannel.svg';
import { ReactComponent as MessengerIcon } from 'assets/bosta-icons/connectMessanger.svg';
import { ReactComponent as InstagramIcon } from 'assets/bosta-icons/instagramColored.svg';

export const META = 'meta';

export const SOCIAL_PLATFORMS = [
  {
    name: META,
    description: 'meta_description',
    icon: MetaIcon,
    subIcon: FacebookAndInstagram,
    isActivated: true
  }
];

export const FACEBOOK_BASE_URL = 'https://www.facebook.com/';
export const INSTGRAM_BASE_URL = 'https://www.instagram.com/';
export const FACEBOOK_CONFIG_ID = '1186715955376261';
export const FACEBOOK_CONFIG_ID_MESSENGER = '674334524835529';
export const FACEBOOK_CONFIG_ID_WHATSAPP = '1207313467324322';
export const FACEBOOK_CONFIG_ID_INSTAGRAM = '370970888648262';

export const CHATS_SOCIAL_PLATFORMS = [
  {
    name: 'chats_plugins.install_plugins.facebook_messenger',
    nameResponsive: 'chats_plugins.install_plugins.messenger',
    description: 'meta_description',
    icon: MessengerIcon,
    isActivated: true,
    configId: FACEBOOK_CONFIG_ID_MESSENGER,
    keyName: 'messenger'
  },
  // {
  //   name: 'WhatsApp',
  //   description: 'whatsApp_description',
  //   icon: WhatsappIcon,
  //   configId: FACEBOOK_CONFIG_ID_WHATSAPP,
  //   keyName: 'whatsapp'
  // },
  {
    name: 'chats_plugins.install_plugins.instagram_messenger',
    nameResponsive: 'chats_plugins.install_plugins.instagram',
    description: 'instagram_description',
    icon: InstagramIcon,
    configId: FACEBOOK_CONFIG_ID_INSTAGRAM,
    keyName: 'instagram'
  }
];

export const META_WEBHOOK_UPDATE = 'META_WEBHOOK_UPDATE';
export const DRAFT_ORDER_NOTIFICATION = 'DRAFT_ORDER_NOTIFICATION';

export const CONNECT_PLUGIN_MODAL = {
  MESSENGER: {
    key: 'messenger',
    title: 'chats_plugins.install_plugins.connect_your_fb',
    follow_steps: 'chats_plugins.install_plugins.follow_steps',
    sub_title: 'chats_plugins.install_plugins.connect_with_fb_messenger',
    icon: <MessengerIcon />,
    select_page: 'select_fb_pages_to_connect_sllr_chat_with',
    page: 'chats_plugins.install_plugins.facebook_page',
    disconnectTitle: 'chats_plugins.install_plugins.diconnect_fb_messanger',
    add_webHook: 'add_sllr_webhook_link_to_fb',
    webhook_link: 'chats_plugins.install_plugins.fb_webhook_link',
    video_title: 'chats_plugins.install_plugins.how_to_connect_fb_messenger'
  },
  WHATSAPP: {
    key: 'whatsApp',
    title: 'chats_plugins.install_plugins.connect_whatsApp',
    follow_steps: 'chats_plugins.install_plugins.follow_steps_whatsApp',
    sub_title: 'chats_plugins.install_plugins.connect_with_whatsApp_messenger',
    icon: <WhatsappIcon />
  },
  INSTAGRAM: {
    key: 'instagram',
    title: 'chats_plugins.install_plugins.connect_instagram',
    follow_steps: 'chats_plugins.install_plugins.follow_steps_instagram',
    sub_title: 'chats_plugins.install_plugins.connect_with_instagram_messenger',
    icon: <InstagramIcon />,
    select_page: 'select_instagram_pages_to_connect',
    page: 'chats_plugins.install_plugins.instagram_page',
    disconnectTitle:
      'chats_plugins.install_plugins.disconnect_instagram_messenger',
    add_webHook: 'add_sllr_webhook_link_to_instagram',
    webhook_link: 'chats_plugins.install_plugins.instagram_webhook_link',
    video_title:
      'chats_plugins.install_plugins.how_to_connect_instagram_messenger'
  }
};
